<div class="navbar__modes">
  @for (gameCard of GAME_CARDS; track gameCard.mode) {
    @if (!gameCard.hideInMain) {
      <a
        class="navbar__mode navbar__mode_{{ gameCard.mode }} link"
        [routerLink]="gameCard.routerLink"
        routerLinkActive="is-active"
        aria-label="game mode"
        [tp]="gameCard.title"
        tpPlacement="right"
      ></a>
    }
  }
</div>
